import { http } from 'novapay-ui';

export default (eventName, payload) =>
	http('/v3/fe-log', {
		method: 'POST',
		data: { event: eventName, payload }
	}).catch(() => null);
